<template src="./template.html"></template>

<script>
import CreateProject from "@/components/Projects/CreateDialog/index"
import EditCProject from "@/components/Projects/EditDialog/index"
import DeleteProject from "@/components/Projects/DeleteDialog/index"
import ViewProject from "@/components/Projects/ViewDialog/index"
export default {
  name: "ProjectsPage",
  components: {
    CreateProject,
    EditCProject,
    DeleteProject,
    ViewProject
  },
  data() {
    return {
      headers: [
        { text: '', value: 'data-table-expand' },
        {
          text: '檢視',
          align: 'start',
          value: 'View',
          width: 80
        },
        {
          text: '客戶名稱',
          align: 'start',
          value: 'CustomerID',
        },
        {
          text: '案件標題',
          align: 'start',
          value: 'Name',
        },
        {
          text: '投放項目',
          align: 'start',
          value: 'ProjectType',
        },
        {
          text: '投放預算',
          align: 'start',
          value: 'Budget',
        },
        { text: '開始日期', value: 'StartDate' },
        {
          text: '狀態',
          align: 'start',
          value: 'Status',
        },
        { text: '動作', value: 'actions', sortable: false },
      ],
      footerprops: {
        'items-per-page-text': '每頁顯示',
      },
      status_array: [
        {
          key: "All",
          value: "全部狀態"
        },
        {
          key: "W",
          value: "未審核"
        },
        {
          key: "P",
          value: "尚未開始"
        },
        {
          key: "D",
          value: "進行中"
        },
        {
          key: "E",
          value: "結束"
        },
        {
          key: "C",
          value: "未通過"
        },
      ],
      project: [],
      customers: [],
      customer_auth: [],
      active_status: "All",
      active_customer: "All",
      date: ["", ""],
      menu: false,
      modal: false,
      expanded: [],
    }
  },

  created() {
    let date = new Date().toISOString().substr(0, 7)
    let now_year = parseInt(date.substr(0, 4))
    let now_month = parseInt(date.substr(5, 2))
    this.date[0] = new Date(now_year, now_month - 1, 1).Format("yyyy-MM-dd")
    this.date[1] = new Date(now_year, now_month, 0).Format("yyyy-MM-dd")
    this.LoadAdminData()
  },

  methods: {
    OpenCreate() {
      this.$refs.CreateProject.Open()
    },
    OpenEdit(item) {
      this.$refs.EditCProject.Open(item)
    },
    OpenView(item) {
      this.$refs.ViewProject.Open(item)
    },
    OpenDelete(item) {
      this.$refs.DeleteProject.Open(item)
    },
    ChangeDate(date) {
      if (new Date(date[0]) > new Date(date[1])) {
        date = date.reverse()
      }
      this.$refs.menu.save(date)
    },
    ProjectTypeFilter(type) {
      if (type == null) {
        return ""
      }
      let now_type = Object.keys(this.project_type).filter(item => item == type)
      return (now_type.length > 0) ? now_type[0] : ""
    },
    ProjectTypeColor(type) {
      return this.$store.state.project_type_color[type]
    },
    ProjectStatusEnable(item) {
      if (this.account().role == "A") {
        return true
      }
      else if (this.account().role != 'C' && this.account().role != 'V' && item.Status != 'W' && item.Status != 'C') {
        return true
      }
      else {
        return false
      }

    },
    StatusColorFilter(status) {
      let colors = {
        W: "blue--text",
        P: "deep-orange--text text--darken-4",
        D: "green--text text--darken-3",
        E: " blue-grey--text text--lighten-2",
        C: "amber--text text--accent-4"
      }
      return colors[status]
    },
    CustomerFilter(customer) {
      let now_customer = this.customers.filter(item => parseInt(item.CustomerID) == parseInt(customer))
      return (now_customer.length > 0) ? now_customer[0].Name : ""
    },
    ExpandRow(item) {
      this.expanded = [item]
    },
    StatusFilter(status) {
      return this.status_array.filter(item => item.key == status)[0].value;
    },
    StatusListFilter() {
      if (this.account().role == "A") {
        return [
          {
            key: "W",
            value: "未審核"
          },
          {
            key: "P",
            value: "尚未開始"
          },
          {
            key: "D",
            value: "進行中"
          },
          {
            key: "E",
            value: "結束"
          },
          {
            key: "C",
            value: "未通過"
          },
        ]
      }
      else {
        return [
          {
            key: "P",
            value: "尚未開始"
          },
          {
            key: "D",
            value: "進行中"
          },
          {
            key: "E",
            value: "結束"
          },
        ]
      }
    },
    StatusProjectsFilter(projects) {
      if (this.active_status == "All") {
        return projects
      }
      else {
        return projects.filter(item => item.Status == this.active_status)
      }
    },
    async LoadCustomerData() {
      this.loading = true
      let response = await this.GetData("/admin/customer")
      this.loading = false
      if (response != "error") {


        let Data = response
        Data.forEach(item => {
          Object.keys(this.customer_auth).forEach(customer => {
            item.CustomerID == customer ? item.Admin = this.customer_auth[customer] : ""
          })
        });
        this.customers = []
        this.customers.push({ Name: "全部客戶", CustomerID: "All" })
        if (this.account().role == "C") {
          Data.forEach(item => {
            if (item.Admin.filter(account => account == this.account().id).length > 0) {
              this.customers.push(item)
            }
          })
        }
        else {
          this.customers = this.customers.concat(Data)
        }


        //this.customers = this.customers.concat(response)
        this.active_customer = this.customers[0].CustomerID

        this.LoadData()
      }
    },
    async UpdateStatus(key, item) {
      item.Status = key
      this.loading = true
      let response = await this.SendData("/admin/project", "patch", { Data: item })
      this.loading = false
      if (response != "error") {

        this.$store.commit("SetSnackBar", { status: true, content: "已成功更新廣告案件" })
        this.LoadData()
      }
    },
    async LoadData() {
      this.loading = true
      let response = await this.GetData("/admin/project")
      this.loading = false
      if (response != "error") {

        this.project = []
        this.project = response.filter(item => this.customers.filter(customer => customer.CustomerID == item.CustomerID).length > 0)
        this.project.sort((A, B) => {
          return new Date(B.StartDate) - new Date(A.StartDate)
        })
        this.CheckEndDate()
      }
    },
    async CheckEndDate() {
      for (let item of this.project) {
        let end_date = new Date(item.EndDate)
        let now_date = new Date()
        if (now_date > end_date && item.Status != "E" && item.Status != "C") {
          await this.UpdateStatus("E", item)
        }
      }
    },
    async LoadAdminData() {
      this.loading = true
      let response = await this.SendData("/admin/customer/auth/get", "post", { Data: {} })
      this.loading = false
      if (response != "error") {

        this.customer_auth = response
        this.LoadCustomerData()
      }
    },
    account() {
      if (this.$cookie.get("account") == null) {
        this.$store.commit("SetSnackBar", {
          status: true,
          content: "帳號驗證錯誤，請重新登入"
        })
        this.$cookie.delete('account');
        this.$cookie.delete('user_token');
        this.$router.push("/login")
        return { name: "", role: "" }
      }
      else {
        return JSON.parse(this.$cookie.get("account"))
      }
    }
  },
  filters: {
    word_break(val) {
      if (val.length <= 12) {
        return val
      }
      else {
        return val.substring(0, 12) + "..."
      }
    },
    currency(price) {
      if (price == null) {
        return " $0"
      }
      let new_price = Math.abs(parseInt(price)).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      return (parseInt(price) < 0) ? "- $" + new_price : " $" + new_price
    },
  },
  computed: {
    project_type() {
      return this.$store.state.project_type
    },
    dateRangeText() {
      return this.date.join(' ~ ')
    },
    filter_projects() {
      if (this.active_customer == "All") {
        return this.StatusProjectsFilter(this.project.filter(item => {
          if (new Date(item.StartDate) >= new Date(this.date[0])) {
            return item
          }
        }))
      } else {
        return this.StatusProjectsFilter(this.project.filter(item => {
          if (item.CustomerID == this.active_customer && new Date(item.StartDate) >= new Date(this.date[0])) {
            return item
          }
        }))
      }
    },

  }
}
</script>